import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'

const SIZE_MAP = {
  width: 348,
  aspectRatio: '2:1',
}

function HelloFreshLogo() {
  const intl = useIntl()
  return (
    <Image
      image={{ id: 'hello-fresh-logo' }}
      width={SIZE_MAP.width}
      aspectRatio={SIZE_MAP.aspectRatio}
      gravity="center"
      alt={intl.formatMessage({
        id: 'OrmF-k7FuDvZ4Wdkj5GH',
        defaultMessage: 'Hello Fresh logo',
        description: 'Accessible alt text for the Hello Fresh partner logo image',
      })}
    />
  )
}

export default HelloFreshLogo
